import React from 'react';
//@ts-ignore
import ReactCardCarousel from "react-card-carousel";
import styled, { keyframes } from 'styled-components';
import cx from '../../../../utils/cx';

const rotateAnimation = keyframes`
	0%{background-position:0% 50%}
	50%{background-position:100% 50%}
	100%{background-position:0% 50%}
`

const CardCarouselWrapper = styled.div`
    > div {
        > div {
           cursor: pointer !important; //tüm cardların içindeki divlerin cursor'ının pointer olmasını sağlar
            &:has(> .active) {
                cursor: unset !important; //active classı olanların cursor'ının unset olmasını sağlar
            }
            &::after {
                animation: ${rotateAnimation} 1s ease infinite;
                background-image: linear-gradient(to bottom right, #b827fc 0%, #2c90fc 25%, #b8fd33 50%, #fec837 75%, #fd1892 100%);
                background-size: 150% 150%;
                position: absolute;
                top: -4px; bottom: -4px;
                left: -4px; right: -4px;
                content: '';
                z-index: -1;
                border-radius: 16px;

                &.noAnimation {
                    background-image: none;
                    animation: none;
                }
            }
        }
    }

    &.noCardAnimation {
        > div {
            > div {
                &::after {
                    display: none;
                }
                box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1) !important;
                background-color: ${({ theme }) => theme.newBg3};
                border-radius: 16px;
                padding: .5rem;
            }
        }
    }
`;



interface ICardCarouselProps {
    children: any[];
    autoPlay?: boolean;
    autoPlaySpeed?: number;
    alignment?: "vertical" | "horizontal";
    spread?: "wide" | "medium" | "narrow";
    noCardAnimation?: boolean;
}

const CardCarousel = (props: ICardCarouselProps) => {
    const ref = React.useRef<any>(null);
    const [currentIndex, setCurrentIndex] = React.useState(0);

    const onAfterChange = React.useCallback(() => {
        setCurrentIndex(ref.current?.getCurrentIndex());
    }, [ref.current]);

    const getChildStyle = React.useCallback((index: number): React.CSSProperties => {
        return {
            pointerEvents: index == currentIndex ? 'auto' : 'none',
            cursor: index == currentIndex ? "initial" : "pointer !important"
        }
    }, [currentIndex]);

    return (
        <CardCarouselWrapper className={cx({ noCardAnimation: props.noCardAnimation })}>
            <ReactCardCarousel
                ref={ref}
                afterChange={onAfterChange}
                autoplay={props.autoPlay}
                autoplay_speed={props.autoPlaySpeed}
                spread={props.spread}
                alignment={props.alignment}
            >
                {props.children?.map((child: any, index: number) => {
                    return (
                        <div key={"cardCarouselItem-" + index} style={getChildStyle(index)} className={cx({ active: index == currentIndex })}>
                            {child}
                        </div>
                    )
                })}
            </ReactCardCarousel>
        </CardCarouselWrapper>
    )
}

export default CardCarousel;